import { TextField, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const ProfileFirstName = ({ errors, data, register }) => {
  const theme = useTheme();
  const { t } = useTranslation('global');
  return (
    <TextField
      fullWidth
      helperText={errors?.firstName?.message}
      FormHelperTextProps={{
        style: { margin: 0, color: theme.palette.error.main },
        'data-testid': 'helpertext-profile-first-name',
      }}
      inputProps={{ 'data-testid': 'profile-name', maxLength: 256 }}
      label={t('modalProfile.firstName')}
      required={true}
      size="small"
      data-testid="firstName"
      defaultValue={data?.firstName}
      {...register('firstName', {
        required: t('errors.required'),
        maxLength: {
          value: t('modalProfile.validation.firstName.value'),
          message: t('modalProfile.validation.firstName.message', {
            limit: t('modalProfile.validation.firstName.value'),
          }),
        },
      })}
      error={!!errors.firstName}
    />
  );
};

export default ProfileFirstName;
